var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010002;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.4,291.4l57.5-57.3l-58.6-58.6L417.9,233c-24.1-16.4-51.5-27.7-81-33.5v-81.3h-82.7v81.3 c-29.6,5.7-56.9,17-80.9,33.4l-57.5-57.5l-58.5,58.6l57.3,57.3c-16.1,24.1-27.5,51.3-33.2,81H0v82.6h81.4 c5.7,29.5,17.1,56.8,33.2,80.9l-57.3,57.5l58.4,58.5l57.5-57.4c24,16.3,51.3,27.6,80.9,33.4v81.4H337v-81.4 c29.5-5.7,56.9-17,81-33.3l57.3,57.3l58.6-58.5L476.5,536c16.3-24,27.7-51.4,33.2-80.9h81.5v-82.6h-81.5 C504.1,342.7,492.8,315.5,476.4,291.4z M295.5,504.1c-49.8,0-90.2-40.6-90.2-90.5c0-49.8,40.4-90.3,90.2-90.3 c49.9,0,90.4,40.5,90.4,90.3C386,463.5,345.5,504.1,295.5,504.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "800,413.6 720.7,299.4 720.7,363.4 616.3,363.4 616.3,463.9 720.7,463.9 720.7,528  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductManagement);
export default __webpack_public_path__ + "static/media/productManagement.4e72bcf8b48009e9bbaebaa7d2a20eca.svg";
export { ForwardRef as ReactComponent };